export function reactionMembershipIdentity(membership) {
    return String(membership?.documentId ?? membership?.id ?? "");
}

export function reconcileRequestedReaction(message, currentMembership, emoji, serverMessage = null) {
    const currentKey = reactionMembershipIdentity(currentMembership);
    const base = serverMessage ? {...message, ...serverMessage} : {...message};
    const sourceReactions = Array.isArray(serverMessage?.reactions)
        ? serverMessage.reactions
        : (Array.isArray(message?.reactions) ? message.reactions : []);

    if (!currentKey) return {...base, reactions: sourceReactions};

    const otherReactions = sourceReactions.filter((reaction) => (
        reactionMembershipIdentity(reaction?.user) !== currentKey
    ));
    if (!emoji) return {...base, reactions: otherReactions};

    const confirmedReaction = sourceReactions.find((reaction) => (
        reactionMembershipIdentity(reaction?.user) === currentKey
        && reaction?.emoji === emoji
    ));
    const currentReaction = confirmedReaction || {
        documentId: `pending-reaction-${message?.documentId ?? message?.id}-${currentKey}`,
        emoji,
        reactedAt: new Date().toISOString(),
        user: currentMembership,
    };

    return {...base, reactions: [...otherReactions, currentReaction]};
}
